
<template>
  <!--添加物业公司-->
  <div>
    <x-addEdit
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="gps" slot-scope="{formItem}">
      <x-location
        ref="location"
        :form="$children[0].form"
        :inputKey="inputKey"
        :position="position"
        :lngLat="lngLat"
        :locationData="formItem">
      </x-location>
    </template>
  </x-addEdit>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import {REG, MESSAGE} from '@/utils/vlidator';
let decoratorOptions = {
  areaId: {
    rules: [{ required: true, message: '请选择所属城市' }]
  },
  propertyFullName: {
    rules: [
      { required: true, message: '请输入公司名', whitespace: true },
      { min: 2, max: 50, message: '公司名为2-50位' }
    ]
  },
  trueName: {
    rules: [
      { required: true, message: '请输入联系人', whitespace: true },
      { min: 1, max: 10, message: '联系人为1-10位' }
    ]
  },
  mobilePhone: {
    rules: [
      { required: true, message: '请输入手机号码', whitespace: true },
      { pattern: REG.mobile, message: MESSAGE.mobile }
    ]
  },
  mapLng: {
    validateTrigger: 'blur',
    rules: [{ required: true, message: '请定位经度' }]
  },
  mapLat: {
    rules: [{ required: true, message: '请定位纬度' }]
  },
  propertyAddress: {
    rules: [
      { required: true, message: '请输入公司地址', whitespace: true },
      { min: 2, max: 50, message: '公司地址为2-50位' }
    ]
  },
  contractNumber: {
    rules: [
      { whitespace: true, message: '不能输入空格' },
      { min: 2, max: 20, message: '合同编号为2-20位' }
    ]
  },
  businessNumber: {
    validateTrigger: 'blur',
    rules: [{ whitespace: true }]
  },
  legalName: {
    validateTrigger: 'blur',
    rules: [{ whitespace: true }]
  },
  businessAddress: {
    validateTrigger: 'blur',
    rules: [{ whitespace: true }]
  },
  businessImg: {
    validateTrigger: 'blur'
  },
  legalImg: {
    validateTrigger: 'blur'
  }
};
export default {
  mixins: [fetchSelect],
  name: 'addCompany',
  data () {
    return {
      newAreas: undefined,
      lngLat: [],
      position: '',
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'propertyAddress'
      },
      formList: [
        {
          label: '所属城市',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所属城市',
          handle: this.regionChange,
          displayRender: this.regionDisplayRender,
          expandTrigger: 'click',
          loadData: e => {
            this.newRegionSelect(0, 'formList', '1,2,3', e);
          },
          props: ['areaId', decoratorOptions.areaId]
        },
        {
          label: '公司名',
          inputType: 'input',
          options: [],
          placeholder: '请输入公司名',
          props: ['propertyFullName', decoratorOptions.propertyFullName]
        },
        {
          label: '联系人',
          inputType: 'input',
          options: [],
          placeholder: '请输入联系人',
          props: ['trueName', decoratorOptions.trueName]
        },
        {
          label: '联系人手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入联系人手机号',
          props: ['mobilePhone', decoratorOptions.mobilePhone]
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['mapLng', decoratorOptions.mapLng]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['mapLat', decoratorOptions.mapLat]
            }
          ]
        },
        {
          label: '公司地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入公司营业执照注册地址',
          props: ['propertyAddress', decoratorOptions.propertyAddress]
        },
        {
          label: '合同编号',
          inputType: 'input',
          options: [],
          placeholder: '请输入合同编号',
          props: ['contractNumber', decoratorOptions.contractNumber]
        },
        {
          label: '营业执照号',
          inputType: 'input',
          options: [],
          placeholder: '请输入营业执照号',
          props: ['businessNumber', decoratorOptions.businessNumber]
        },
        {
          label: '法人代表',
          inputType: 'input',
          options: [],
          placeholder: '请输入法人代表',
          props: ['legalName', decoratorOptions.legalName]
        },
        {
          label: '注册地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入注册地址',
          props: ['businessAddress', decoratorOptions.businessAddress]
        },
        {
          label: '营业执照照片',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: 'common/upload',
            iconUrl: 'businessImgUrl',
            iconName: 'file_name',

            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            uploadType: 4
          },
          props: ['businessImg', decoratorOptions.businessImg]
        },
        {
          label: '法人持身份证照',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: 'common/upload',
            iconUrl: 'legalImgUrl',
            iconName: 'file_name',

            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            uploadType: 4
          },
          props: ['legalImg', decoratorOptions.legalImg]
        },
        {
          label: '合同期限',
          inputType: 'datePick',
          options: [],
          placeholder: '',
          props: ['contractTime', {
            rules: [{ required: false, message: '请选择合同期限' }]
          }]
        }
      ],
      formKey: {
        areaId: '',
        propertyFullName: '',
        trueName: '',
        mobilePhone: '',
        mapLng: '',
        mapLat: '',
        propertyAddress: '',
        contractNumber: '',
        businessNumber: '',
        legalName: '',
        businessAddress: '',
        businessImg: '',
        legalImg: '',
        contractTime: ''
      },
      addParam: {
        url: '/property',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/property/',
        reqHandle: this.editReqHandle,
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/property/',
        resHandle: this.detailResHandle //
      }
    };
  },
  created () {
    this.setRequire();
    this.newRegionSelect(0, 'formList');
  },
  mounted () {
  },
  methods: {
    /* 设置合同有效期是否为必填 */
    setRequire () {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'contractTime') {
          let rule = props[1].rules[0];
          this.$route.query.verifyStatus === '1' ? rule.required = true : rule.required = false;
        }
      });
    },
    /** region displayer 事件 */
    regionDisplayRender (labels) {
      this.regionChange(undefined, labels);
    },
    regionChange (val, selected) {
      let isArray = Array.isArray(val);
      if (isArray) { // 判断是change事件还是 displayRender
        console.log('company $refs: ', this.$refs.location);
        this.$refs.location && this.$refs.location.positionChanged();
      }

      if (selected && selected.length > 1) {
        let isCity = this.$store.state.citys.some(el => {
          return el === (isArray ? selected[0].label : selected[0]);
        });
        if (isCity) { // 判断是否为直辖市
          this.position = isArray ? selected[0].label : selected[0];
        } else {
          this.position = isArray ? selected[1].label : selected[1];
        }
      }
      if (val && selected && selected.length > 0) {
        let temp = [];
        selected.forEach(item => {
          let i = item.level - 1;
          temp[i] = item.value;
        });
        for (let i = 0; i < 3; i++) {
          if (temp[i] == undefined) {
            temp[i] = 0;
          }
        }
        this.newAreas = temp.toString();
      }
    },
    detailResHandle (data) {
      if (data.area) {
        let area = data.area.split(' ');
        let isCity = this.$store.state.citys.some(el => el === area[0]);
        if (isCity) { // 判断是否为直辖市
          this.position = area[0];
        } else {
          this.position = area[1];
        }
      }

      if (data.mapLng && data.mapLat) {
        let lng = parseFloat(data.mapLng);
        let lat = parseFloat(data.mapLat);
        lng !== 0 && lat !== 0 && (this.lngLat = [lng, lat]);
      }

      // if (data.areaId) {
      //   this.newRegionSelectByIds(0, data.areaId);
      // }
      let areas;
      if (data.areaId) {
        areas = data.areaId;
        this.newAreas = areas.toString();
        areas.forEach((i, index) => {
          if (i == 0) {
            areas.splice(index, 1);
          }
        });
        this.newRegionSelectByIds(0, areas, 3);
      }

      let formValues = {};
      formValues.legalImg = '';
      formValues.businessImg = '';
      return formValues;
    },
    reqHandle (param) {
      // param.areaId = param.areaId.join(',');
      if (param.contractTime) {
        param.contractTime = param.contractTime.format('YYYY-MM-DD');
      } else {
        param.contractTime = undefined;
      }
      param.areaId = this.newAreas;
      return param;
    },
    editReqHandle (param) {
      param.areas = this.newAreas;
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
